import React, {Component} from 'react';
import {connect} from "react-redux";
import {ConnectedProps} from "react-redux/es/exports";
import {AccessBase} from "../../../../domain/access/BaseAccess";
import AccessContainer from "../../../access/AccessContainer";
import RoleHelper from "../../../../RoleHelper";
import {PolicyState} from "../../../../redux/reducers/PolicyReducer";
import {changePolicy, changePolicyIsUpdate} from "../../../../redux/actions/PolicyActions";
import {RootState} from "../../../../redux/store";

class PolicyAccessComponent extends Component<Props> {
  render() {
    const {policy: {policy}} = this.props;
    const access: AccessBase = {permission: policy.permission, collaborators: policy.collaborators};
    return (
      <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage("Cra")}/>
    );
  }

  private changeAccess = (access: AccessBase) => {
    const {policy: {policy}, changePolicy} = this.props;
    policy.permission = access.permission;
    policy.collaborators = access.collaborators;
    changePolicy(policy);
  }
}

interface Props extends ReduxProps {

}

const mapStateToProps = (state: RootState) => ({
  policy: state.policy as PolicyState,
  lastCategory: state.page.lastCategory
})

const mapDispatchToProps = {changePolicy, changePolicyIsUpdate}
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>
export default connector(PolicyAccessComponent);